import React, { Fragment, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useNoteAlert } from "../../../Context/pleaseNote";
import { useAuth } from "../../../Context/AuthContext";
import { axiosInstance } from "../../../axios/axiosInstance";
import $ from "jquery";

import "datatables.net";
import "datatables.net-responsive";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";

export const PaidInvoices = ({ invoices = [] }) => {
  const tableRef = useRef(null);
  const dtRef = useRef(null);

  const navigate = useNavigate();

  const { showDialogAlert, hideNoteAlert, showNoteAlert } = useNoteAlert();

  const { companyId } = useAuth();
  const { loadStoredCard, sendInvoiceSignal } = useGlobalFunction();

  useEffect(() => {
    if (!tableRef.current) return;

    const $table = $(tableRef.current);

    // Destroy old instance if exists
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      $table.DataTable().destroy(false);
    }

    function markFirstVisible() {
      $table.find("tbody tr").each(function () {
        const $cells = $(this).children("td").removeClass("orderCustomClass");

        const $firstVisible = $cells
          .filter(function () {
            const $td = $(this);

            return $td.is(":visible") && !$td.hasClass("dtr-hidden");
          })
          .first();

        $firstVisible.addClass("orderCustomClass");
      });
    }

    dtRef.current = $table.DataTable({
      data: invoices || [],
      responsive: {
        details: {
          type: "column",
          target: "tr",
        },
      },
      autoWidth: false,
      searching: false,
      paging: false,
      info: false,
      destroy: true,
      columns: [
        {
          data: "status",
          defaultContent: "",
          render: function (data) {
            if (!data) return "";

            const status = data.toLowerCase();

            if (status.includes("over")) {
              return `<span class="status-overdue">Over Due</span>`;
            }

            if (status.includes("credit")) {
              return `<span class="status-credit">Credit</span>`;
            }

            return data;
          },
        },

        {
          data: "invoiceDate",
          defaultContent: "",
          render: function (data) {
            if (!data) return "";

            const date = new Date(data);

            if (isNaN(date)) return data;

            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();

            return `${day}-${month}-${year}`;
          },
        },

        { data: "invoiceNo", defaultContent: "" },

        { data: "orderRef", defaultContent: "" },

        {
          data: "pdfkey",
          orderable: false,
          defaultContent: "",
          render: function (data, type, row) {
            if (!row.invoiceNo || row.invoiceNo === "0") {
              return "";
            }

            return `
            <a
              class="HyperLink2"
              href="javascript:void(0)"
              data-pdfkey="${data}"
              data-invoiceno="${row.invoiceNo}"
            >
              <img
                height="24"
                src="https://cdn.wes.com.au/wes/icons/Pdf.png"
                alt="View Invoice"
              />
            </a>
          `;
          },
        },

        {
          data: "amountCharged",
          defaultContent: "",
          render: function (data) {
            if (!data) return "$0.00";

            return `$${parseFloat(data).toFixed(2)}`;
          },
        },
      ],
      language: {
        paginate: {
          previous: '<i class="fa fa-chevron-left"></i>',
          next: '<i class="fa fa-chevron-right"></i>',
        },
      },

      columnDefs: [
        {
          targets: [5],
          orderable: false,
        },
        {
          targets: [2, 3],
          className: "orderListing",
          responsivePriority: 3,
        },
        {
          targets: [4],
          className: "text-center",
        },
      ],

      drawCallback: function () {
        markFirstVisible();
      },
    });

    $table.on("click", ".HyperLink2", async function (e) {
      e.preventDefault();
      const $link = $(this);
      const invoiceNo = $link.data("invoiceno");
      if (!invoiceNo) return;

      const $img = $link.find("img");
      const originalSrc = $img.attr("src");
      const loadingSrc = "https://cdn.wes.com.au/wes/images/loading.gif";

      $img.attr("src", loadingSrc);
      $link.css("pointer-events", "none");

      try {
        await sendInvoiceSignal(invoiceNo, invoiceNo);
      } finally {
        $img.attr("src", originalSrc);
        $link.css("pointer-events", "");
      }
    });
    // =========================
    // EVENTS
    // =========================

    $table.on("responsive-resize.dt", function () {
      markFirstVisible();
    });

    $table.on("page.dt", function () {
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        300,
      );
    });

    // =========================
    // CLEANUP
    // =========================

    return () => {
      $table.off(".dt");
      $table.off("change");

      if (dtRef.current) {
        dtRef.current.clear();
        dtRef.current.destroy(false);
        dtRef.current = null;
      }
    };
  }, []);

  // =========================
  // UPDATE TABLE DATA
  // =========================
  useEffect(() => {
    const dt = dtRef.current;

    if (!dt) return;

    dt.clear();

    if (Array.isArray(invoices) && invoices.length > 0) {
      dt.rows.add(invoices);
    }

    dt.draw(false);
  }, [invoices]);

  // =========================
  // DELETE
  // =========================

  return (
    <Fragment>
      <div className="myAcc-list  myaccount-overview">
        <h2>Paid Invoice</h2>
      </div>
      <div className="table-responsive" style={{ paddingBottom: "20%", paddingTop: "20px" }}>
        <table ref={tableRef} className="table table-striped display nowrap orderlist-table" style={{ width: "100%" }}>
          <thead>
            <tr>
              <th>Status</th>
              <th>Invoice Date</th>
              <th>Invoice No</th>
              <th>Customer po#</th>
              <th>View Invoice</th>
              <th>Amount</th>
            </tr>
          </thead>
        </table>
      </div>
    </Fragment>
  );
};
